/**
 * @owner @Appboy/core-objects
 */
export const customObjectsOnboardingStatus = "/data_objects/onboarding_status" as const;
